const TermsAndConditions = () => {
    return (
        <div className='container mx-auto py-8 px-8'>
            <div className='bg-white p-4 rounded-lg shadow-lg'>
                <div className='rounded-lg p-4'>
                    <div className='flex items-center self-center space-x-4'>
                        <span className='text-2xl font-semibold text-primary'>Terms and Conditions&nbsp;&nbsp;&nbsp;</span>
                        <hr className='flex-grow border-t border-lightGray' />
                    </div>
                    <div className='space-y-4 terms-scroll pr-2' style={{ height: '500px', overflowY: 'scroll' }}>
                        <div>
                            <h2 className='text-md font-semibold mt-4'>1. DEFINITIONS.</h2>
                            <p className='mt-2'>
                                AS USED THROUGHOUT THESE TERMS AND CONDITIONS, THE FOLLOWING TERMS SHALL HAVE THE MEANINGS AS SET FORTH
                                BELOW:
                            </p>
                            <ul className='pl-4 space-y-2 text-justify'>
                                <li>a. "Seller" means, NV5 Geospatial Solutions, Inc., operating in the State of Colorado.</li>
                                <li>
                                    b. "Buyer" means the person, firm, corporation or academic institution that is purchasing Seller’s
                                    product(s).
                                </li>
                                <li>
                                    c. "Software" shall mean computer programs provided to Buyer as a licensee by an approved source, and
                                    any upgrades, updates, bug fixes or modified versions (collectively "Upgrades") during the first year of
                                    purchase of the software.
                                </li>
                                <li>
                                    d. "EULA" means Seller’s End User License Agreement which governs the use of the Software. Contact your
                                    sales representative for a copy or you may find a copy at{' '}
                                    <a
                                        href='http://www.nv5geospatialsoftware.com/Company/Legal/EULA.aspx'
                                        className='text-primary underline'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        http://www.nv5geospatialsoftware.com/Company/Legal/EULA.aspx
                                    </a>
                                    .
                                </li>
                                <li>
                                    e. "Software Maintenance Products" shall mean follow-on, license renewal, term limited, technical
                                    support, any upgrades, bug fixes or modified versions to the delivered software separately agreed to by
                                    the Seller and Buyer following the initial year of sale of the original software product. The Software
                                    Maintenance Program may be viewed at{' '}
                                    <a
                                        href='http://www.nv5geospatialsoftware.com/Support/UpdatesMaintenance.aspx'
                                        className='text-primary underline'
                                        target='_blank'
                                        rel='noopener noreferrer'
                                    >
                                        http://www.nv5geospatialsoftware.com/Support/UpdatesMaintenance.aspx
                                    </a>
                                    &nbsp;of contact your sales representative for a copy.
                                </li>
                                <li>
                                    f. "Software Documentation" means written information (whether contained in user or technical manuals,
                                    training manuals, specifications or otherwise) pertaining to the Software and made available by Seller
                                    in any manner (including CD-ROM or online).
                                </li>
                                <li>
                                    g. The Software, related Software Maintenance Products, and Software Documentation offered for sale
                                    qualify as "commercial items" as that term is defined in the Federal Acquisition Regulation (“FAR”) (48
                                    C.F.R.) 2.101, consisting of "commercial computer software" and "commercial software documentation" as
                                    such terms are used in FAR 12.212. Consistent with FAR 12.212 and DoD FAR Suppl. 227.7202-1 through
                                    227.7202-4, and notwithstanding any other FAR or other contractual clause into which this sale may be
                                    incorporated, the end user, whether that be commercial or Government, will acquire the Software and
                                    Software Documentation with only those rights set forth in the EULA. Use of either a) the Software and
                                    any of its Software Maintenance Products, or b), Software Documentation, or both, constitutes agreement
                                    by the end user (either commercial or Government) that the Software and Software Documentation are
                                    "commercial computer software" and "commercial computer software documentation," and constitutes
                                    acceptance of the rights and restrictions herein.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h2 className='text-md font-semibold mt-4'>2. ACCEPTANCE OF CONTRACT.</h2>
                            <p className='text-justify'>
                                Seller’s acceptance of any purchase order issued by Buyer shall be expressly limited to the terms and
                                conditions set forth herein. Any additional or different terms set forth or referenced in Buyer’s purchase
                                order that conflict with these terms and conditions are hereby objected to by Seller and shall not be deemed
                                a part of any resulting order. These terms and conditions represent the entire agreement between the Buyer
                                and Seller pertaining to the subject matter of this order and shall supersede all prior oral and written
                                agreements, proposals, communications and documents.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>3. APPLICABLE LAW.</h2>
                            <p>
                                The validity, performance, and construction of the contract arising from the acceptance of this offer by
                                commercial entities shall be governed as follows:
                            </p>
                            <ul className='pl-4 space-y-2'>
                                <li>
                                    a. For commercial entities, the laws of the State of Colorado without regard to its choice of law rules.
                                </li>
                                <li>
                                    b. For US state and local governments and/or higher education schools governed by state laws, contracts
                                    shall be governed by the laws of the state in which they are located without reference to conflict of
                                    laws principles.
                                </li>
                                <li>c. For the US government, contracts shall be governed by US Federal Laws.</li>
                                <li>d. U.S. Federal Laws shall govern all matters of intellectual property.</li>
                                <li>
                                    e. Contracts will not be governed by the United Nations Convention on Contracts for the international
                                    Sale of Goods, the application of which is expressly excluded.
                                </li>
                            </ul>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>4. ASSIGNMENT.</h2>
                            <p>
                                Neither Seller nor Buyer shall assign any rights or obligations hereunder without the prior express written
                                consent of the other party, except to a third party pursuant to a merger, sale of all or substantially all
                                assets, or other corporate reorganization.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>5. AUDIT.</h2>
                            <p>
                                Notwithstanding any language or provisions in this contract to the contrary, Buyer shall not be allowed the
                                right to audit or examine Seller’s books and records unless required by applicable law.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>6. CHANGES.</h2>
                            <p>
                                No changes, extras or other work shall be authorized unless agreed to by both parties as evidenced by a
                                written amendment to this order signed by duly authorized representatives of Buyer and Seller.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>7. TITLE AND RISK OF LOSS.</h2>
                            <p>
                                Risk of loss shall pass to Buyer upon delivery of the Software, and/or Software Documentation. It is hereby
                                acknowledged and agreed that Buyer shall not obtain title to the Software. In lieu thereof, Buyer shall
                                obtain the license rights granted in the EULA or Software License Agreement.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>8. PAYMENT.</h2>
                            <p>
                                Buyer shall pay for all products within thirty (30) days from (a) the date products are shipped, or (b) date
                                of the invoice, whichever is sooner. Payment will be deemed to have been made when received at Seller’s
                                facilities or when electronically deposited at Seller’s designated financial institution.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>9. TAXES.</h2>
                            <p>
                                As may be applicable by law, any and all taxes, assessments, or duties, which may be imposed upon the
                                production shipment, installation, or sale of the products covered hereby, shall be the sole responsibility
                                of and shall be paid by Buyer.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>10. OPEN SOURCE SOFTWARE.</h2>
                            <p>
                                Certain software libraries and other third party software included in the Software are "free" or "open
                                source" software and are subject to separate license terms ("Open Source Software"). Such Open Source
                                Software is distributed WITHOUT ANY WARRANTY, without even the implied warranty of MERCHANTABILITY or
                                FITNESS FOR A PARTICULAR PURPOSE. Certain Open Source Software has been or may be made available by Seller
                                with the Software or on its web site. Seller is not obligated to provide any warranty, maintenance,
                                technical or other support for the Open Source Software or its use on the Software.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>11. INDEMNITY.</h2>
                            <p>
                                Seller shall defend or settle at its expense a claim or suit against Buyer arising out of or in connection
                                with an assertion that the Software infringes any U.S. copyright or U.S. registered patent. Seller shall
                                indemnify and hold Buyer harmless from and against the damages, costs and expenses (including, without
                                limitation, reasonable legal and expert witness fees), if any, finally awarded in such suit or the amount of
                                the settlement thereof, provided that Seller is notified in writing of the existence of such claim by Buyer
                                within five (5) business days of Buyer’s first learning of the same, and provided that Seller is given full
                                authority to control the defense, cost and settlement of the claim. Seller will not be obligated to defend
                                or otherwise indemnify Buyer in any lawsuit or as to any claim which arises from or relates to: (1) any
                                combination of the Software with another product not supplied by Seller; (2) if such a claim is based upon
                                use of the Software for purposes for which it was not designed; or (3) if the Software has been modified by
                                any party other than Seller. In lieu of the foregoing indemnification obligations, Seller shall have the
                                option, at its expense, either to procure for Buyer the right to continue using the Software or to replace
                                or modify the Software so that it becomes non-infringing, or to refund to Buyer the amount actually paid by
                                the Buyer for the Software.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>12. EXPORT RESTRICTIONS.</h2>
                            <p>
                                The Software is subject to U.S. export controls and may be subject to additional export and import
                                regulations of the country in which the Software is obtained. Buyer agrees that it will not use or otherwise
                                export or re-export the Software except as authorized by United States law and the laws of the jurisdiction
                                in which the Software was obtained. Buyer agrees that it will comply with all applicable laws and
                                regulations governing the export, import, reexport, transfer and use, and that it has the responsibility to
                                obtain any required authorization from the appropriate authority. If Seller receives notice that Buyer is or
                                Buyer becomes identified as a sanctioned or restricted party under applicable law, Seller will not be
                                obligated to perform any of its obligations if such performance would result in violation of the sanctions
                                or restrictions. See{' '}
                                <a
                                    href='https://www.nv5geospatialsoftware.com/Company/Legal'
                                    className='text-primary underline'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    http://www.nv5geospatialsoftware.com/Company/Legal.aspx
                                </a>{' '}
                                for further details on export controls on Seller’s software products.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>13. ORDER OF PRECEDENCE.</h2>
                            <p className='uppercase'>
                                In the event of conflict in any term of any document that governs this purchase, the following order of
                                precedence will apply in descending order of control: EULA, these terms and conditions, purchase order,
                                unless agreed to in writing by both parties.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>14. TERMINATION.</h2>
                            <p>
                                Buyer may terminate any purchase order by giving Seller 10 days' written notice or by returning the Software
                                unopened. Seller will then provide credit or reimbursement to Buyer as solely determined by the Seller.
                            </p>
                        </div>
                        <div className='text-justify'>
                            <h2 className='text-md font-semibold mt-4'>15. GENERAL PROVISIONS.</h2>
                            <p>
                                The English version of these Terms and Conditions and the EULA will be the version used for any required
                                interpretation.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TermsAndConditions
